import {
  stat
} from 'fs'

// 权限dlg组件

const permissionDlg = {
  namespaced: true,

  state: {
    dlgShow: false,

    permissionId: '',

    permissionName: '',
  },

  getters: {
    dlgShow: state => state.dlgShow,

    permissionId: state => state.permissionId,

    permissionName: state => state.permissionName,
  },

  mutations: {
    SET_DLGSHOW: (state, val) => {
      state.dlgShow = val
    },

    SET_PERMISSIONID: (state, val) => {
      state.permissionId = val
    },

    SET_PERMISSIONNAME: (state, val) => {
      state.permissionName = val
    },
  },

  actions: {

  }
}

export default permissionDlg
